import { render, staticRenderFns } from "./ProductVipDetail.vue?vue&type=template&id=390043c7&"
import script from "./ProductVipDetail.vue?vue&type=script&lang=ts&"
export * from "./ProductVipDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ProductVipDetail.vue?vue&type=style&index=0&id=390043c7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports